"use client";

import { c as _c } from "react/compiler-runtime";
import { dateTimeFormatter } from "../formatters/dateTime";
import { useLocale } from "./useLocale";
export const useDateTimeFormatter = () => {
  const $ = _c(2);
  const locale = useLocale();
  let t0;
  if ($[0] !== locale) {
    t0 = dateTimeFormatter(locale);
    $[0] = locale;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
};